import { render, staticRenderFns } from "./AdditionalFieldControl.vue?vue&type=template&id=906acc72&scoped=true&"
import script from "./AdditionalFieldControl.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldControl.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFieldControl.vue?vue&type=style&index=0&id=906acc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906acc72",
  null
  
)

export default component.exports